export class ExpressionLanguageUtile {
  static evaluate(expression: string, context: Record<string, any>): boolean | null {
    try {
      // Create a new function with the expression and context
      const func = new Function(
        ...Object.keys(context),
        `return ${safeVariableAccess(expression)};`,
      );
      // Call the function with the context values
      return func(...Object.values(context));
    } catch (error) {
      console.error('Error evaluating expression:', error);
      return null; // or handle the error as needed
    }
  }

  static parseExpressionForTemplate(expression: string, context: Record<string, any>): any {
    try {
      const func = new Function('ctx', `with (ctx) { return ${safeVariableAccess(expression)}; }`);
      const nestedContext = unflatten(context);
      const result = func(nestedContext);
      if (
        typeof result === 'string' ||
        typeof result === 'number' ||
        typeof result === 'boolean' ||
        result === null
      ) {
        // string or number or boolean or null, can be displayed in the template
        return result;
      }
      try {
        return JSON.stringify(result, null, 2);
      } catch (errorStringify) {
        console.error('Error errorStringify result:', errorStringify);
        return expression;
      }
    } catch (error) {
      console.error('Error evaluating expression:', error);
      return expression;
    }
  }
}

function unflatten(obj: Record<string, unknown>) {
  const result: Record<string, any> = {};
  for (const key in obj) {
    const keys = key.split('.');
    keys.reduce((acc, part, i) => {
      if (i === keys.length - 1) {
        acc[part] = obj[key];
      } else {
        acc[part] = acc[part] || {};
      }
      return acc[part];
    }, result);
  }
  return result;
}

/**
 * Used to avoid to add `?.` everywhere in the expression
 */
function safeVariableAccess(expression: string) {
  return expression.replace(/\./g, '?.');
}
